export enum MicrosoftClarityEvents {
  Scroll25 = 'scroll_25',
  Scroll50 = 'scroll_50',
  Scroll75 = 'scroll75',
  SocialClickFacebook = 'social_click_facebook',
  SocialClickLinkedIn = 'social_click_linkedin',
  EmailClick = 'email_click',
  PhoneClick = 'phone_click',
  RequestCta = 'request_cta',
  AuctionsContactFormTouch = 'auctions_contact_form_touch',
  AuctionsContactFormSubmit = 'auctions_contact_form_submit',
  AuctionsContactFormError = 'auctions_contact_form_error',
  AutoparkContactFormTouch = 'autopark_contact_form_touch',
  AutoparkContactFormSubmit = 'autopark_contact_form_submit',
  AutoparkContactFormError = 'autopark_contact_form_error',
  CarouselSwipe = 'carousel_swipe',
  CarouselOfferSelected = 'carousel_offer_selected',
  CarouselOfferDetails = 'carousel_offer_details',
  SpecialOfferFormTouch = 'special_offer_form_touch',
  SpecialOfferFormSubmit = 'special_offer_form_submit',
  SpecialOfferFormError = 'special_offer_form_error',
  PhoneBannerShown = 'phone_banner_shown',
  PhoneBannerClick = 'phone_banner_clicked',
  PhoneBannerClose = 'phone_banner_accepted',
  PhoneBannerReject = 'phone_banner_closed',
}
